const FEED_REFRESH_EVENT = 'realadvisor:legacy-feed-refresh';

export const emitFeedRefresh = () => {
  window.dispatchEvent(new CustomEvent(FEED_REFRESH_EVENT));
};

export const subscribeFeedRefresh = (listener: () => void): (() => void) => {
  const handler = () => {
    listener();
  };

  window.addEventListener(FEED_REFRESH_EVENT, handler);
  return () => {
    window.removeEventListener(FEED_REFRESH_EVENT, handler);
  };
};
